var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5394 0H0.460554C0.204691 0 0 0.204691 0 0.460554V7.68955C0 7.94542 0.204691 8.15011 0.460554 8.15011C0.716418 8.15011 0.921109 7.94542 0.921109 7.68955V0.921109H15.0789V15.0789H8.26951C8.01365 15.0789 7.80896 15.2836 7.80896 15.5394C7.80896 15.7953 8.01365 16 8.26951 16H15.5394C15.7953 16 16 15.7953 16 15.5394V0.460554C16 0.204691 15.7953 0 15.5394 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99062 9.54883H0.460554C0.204691 9.54883 0 9.75352 0 10.0094V15.5394C0 15.7953 0.204691 16 0.460554 16H5.99062C6.24648 16 6.45117 15.7953 6.45117 15.5394V10.0094C6.45117 9.75693 6.24307 9.54883 5.99062 9.54883ZM5.53006 15.0789H0.921109V10.4699H5.53006V15.0789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.295 4.3564V6.79563C12.295 7.0515 12.4997 7.25619 12.7556 7.25619C13.0114 7.25619 13.2161 7.0515 13.2161 6.79563V3.24425C13.2161 2.98838 13.0114 2.78369 12.7556 2.78369H9.20417C8.94831 2.78369 8.74362 2.98838 8.74362 3.24425C8.74362 3.50011 8.94831 3.7048 9.20417 3.7048H11.6434L7.24938 8.09883C7.06857 8.27964 7.06857 8.56962 7.24938 8.75043C7.33808 8.83913 7.45748 8.88689 7.57347 8.88689C7.68946 8.88689 7.80887 8.84254 7.89756 8.75043L12.295 4.3564Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandView);
export default __webpack_public_path__ + "static/media/expand_view.cddffca4.svg";
export { ForwardRef as ReactComponent };